import { AlertTriangle } from "lucide-react";

export const OTP_DELIVERY_NOTICE = {
  lead: "Can’t find your code?",
  body: "Check junk/spam for an email from hello@pedagogue.io. If it’s missing, check your school’s quarantine or “held mail” folder, or ask IT to release it.",
};

export const OtpDeliveryNotice: React.FC = () => (
  <div
    role="status"
    data-testid="otp-delivery-notice"
    className="rounded-lg border border-pd-line bg-pd-surface px-4 py-3 text-small text-pd-ink"
  >
    <div className="flex gap-2">
      <AlertTriangle aria-hidden="true" className="mt-0.5 shrink-0" size={18} />
      <p>
        <strong>{OTP_DELIVERY_NOTICE.lead}</strong> {OTP_DELIVERY_NOTICE.body}
      </p>
    </div>
  </div>
);
